import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/style.css";
import "@/assets/css/typography.css";
import Vuelidate from "vuelidate";
import vueQuillEditor from "vue-quill-editor";
import PrimaryButton from "@/utils/components/PrimaryButton.vue";
import OutlineButton from "@/utils/components/OutlineButton.vue";
import SearchBar from "@/utils/components/SearchBar.vue";
import InputField from "@/utils/components/InputField.vue";
import FormTags from "./utils/components/FormTags.vue";
import TextArea from "@/utils/components/TextArea.vue";
import MultiSelectSearch from "./utils/components/MultiSelectSearch.vue";
import Checkbox from "@/utils/components/Checkbox.vue";
import DateField from "./utils/components/DateField.vue";
import SingleSelect from "./utils/components/SingleSelect.vue";
import CustomQuillEditor from "./utils/components/CustomQuillEditor.vue";
import Spinner from "./components/Spinner.vue";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VideoPlayer from "./views/utils/Video.vue";
import AudioPlayer from "./views/utils/Audio.vue";
import TextField from "./utils/components/TextField.vue";

Vue.component("datetime", Datetime);

Vue.use(DatePicker);
Vue.use(vueQuillEditor);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.component("PButton", PrimaryButton);
Vue.component("OButton", OutlineButton);
Vue.component("SearchBar", SearchBar);
Vue.component("InputField", InputField);
Vue.component("FormTags", FormTags);
Vue.component("TextArea", TextArea);
Vue.component("Checkbox", Checkbox);
Vue.component("DateField", DateField);
Vue.component("SingleSelect", SingleSelect);
Vue.component("CustomQuillEditor", CustomQuillEditor);
Vue.component("MultiSelectSearch", MultiSelectSearch);
Vue.component("LogoSpinner", Spinner);
Vue.component("VideoPlayer", VideoPlayer);
Vue.component("AudioPlayer", AudioPlayer);
Vue.component("TextField", TextField);

Vue.config.productionTip = false;

Vue.filter("dd_mm_yyyy", (inputDate) => {
  const date = new Date(inputDate);
  const formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${date.getFullYear()}`;
  return formattedDate;
});

Vue.filter("dd_MM_yyyy", (inputDate) => {
  const date = new Date(inputDate);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  // Format the date as "DD Mon, YYYY"
  const formattedDate = `${day} ${month}, ${year}`;
  return formattedDate;
});

Vue.filter("cloudlink", (url) => {
  try {
    const urlObject = new URL(url);
    const pathname = urlObject.pathname;
    const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
    const decodedFileName = decodeURIComponent(fileName);
    return decodedFileName;
  } catch (error) {
    return url;
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation();
      const { handler, exclude } = binding.value;
      let clickedOnExcludedEl = false;
      exclude.forEach((refName) => {
        if (!clickedOnExcludedEl) {
          let excludedEl = vnode.context.$refs[refName];
          excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;

          if (excludedEl) {
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });

      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        if (typeof vnode.context[handler] === "function") {
          vnode.context[handler]();
        } else {
          console.warn(`Handler "${handler}" is not a function`);
        }
      }
    };
    document.addEventListener("click", handleOutsideClick);
  },

  unbind() {
    document.removeEventListener("click", handleOutsideClick);
  },
});
